/**
 * Created by idea on 27/04/2017.
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sort-header',
  templateUrl: 'sort-header.component.html',
  styleUrls: ['./sort-header.component.css'],
})
export class SortHeaderComponent implements OnInit {
  @Input() key: string;
  @Input() defaultType: 'desc' | 'asc';
  @Output() onClick = new EventEmitter<{
    key: string;
    type: 'desc' | 'asc';
  }>();
  public sortType: 'desc' | 'asc';

  constructor() {}
  ngOnInit() {
    if (this.defaultType) {
      this.sortType = this.defaultType;
    }
  }

  onClickHeader() {
    if (!this.sortType || this.sortType === 'asc') {
      this.sortType = 'desc';
    } else {
      this.sortType = 'asc';
    }

    this.onClick.emit({
      key: this.key,
      type: this.sortType,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/sort-header/sort-header.component.ts